<div class="customPanel">
  <h1 class="textM" style="text-align: center; height: 10%" mat-dialog-title>
    {{this.localiser.get("reports.printTitle")}}
  </h1>

  <div mat-dialog-content class="bodyForm" style="">
    <div *ngFor="let proyecto of proyectos" style="width: 100%; margin: 0 auto; text-align: left">
      <mat-checkbox [disabled]="this.zonas[this.proyectos.indexOf(proyecto)].length <= 0" [checked]="isProyectoChecked(proyecto)" (change)="changeProyecto(proyecto, $event.checked)">
        <h3 class="textS marginAuto">{{proyecto.nombre}}</h3>
      </mat-checkbox>
      <div style="margin-left: 3vw" *ngFor="let zona of zonas[data.proyectos.indexOf(proyecto)]">
        <mat-checkbox [checked]="isZonaChecked(proyecto, zona)" (change)="changeZona(proyecto, zona, $event.checked)">
          <h3 class="textS marginAuto">{{zona.nombre}}</h3>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div mat-dialog-actions style="height: 20%">
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("devices.cancel")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="onStartClick()">{{this.localiser.get("reports.print")}}</button>
    </div>
  </div>

</div>
